import React    from 'react';
import crypto   from 'crypto';

export default function Avatar(props) {
    const md5 = crypto.createHash('md5').update(props.email.trim().toLocaleLowerCase()).digest('hex');
    const url = 'https://www.gravatar.com/avatar/' + md5  + '?d=identicon';
    const size = ( props.size === undefined ) ? '30px' : props.size+'px';
    const cls = props.className || '';
    return (<img src={url} height={size} alt='avatar' className={'rounded-circle '+cls} />);
} 